<nav class="navbar border-bottom sticky-top navbar-light bg-white" style="overflow-x: hidden;">
  <div class="container-fluid">
    <div class="row align-items-center w-100 flex-nowrap">
      <div class="col-auto d-md-none">
        <button class="navbar-toggler navbar-toggler-us" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu"
                aria-controls="mobileMenu">
          <div class="navbar-toggler-icon"></div>
        </button>
      </div>
      <div class="col-auto px-0 ms-md-4 border-end">
        <img src="assets/imgs/logos/logo-pjus.svg" style="width:100%; height:48px; min-width: 50px;" alt=""
             class="d-inline-block align-text-top">
      </div>
      <div class="col col-md-auto px-0 ms-md-2">
        Parceiro
      </div>
      <div class="col-auto d-md-none" *ngIf="authUser">
        <app-notificacao-sino></app-notificacao-sino>
      </div>
      <div class="col d-none d-md-block text-end">
        <app-notificacao-sino *ngIf="authUser" class="me-3"></app-notificacao-sino>
        <app-menu-user-avatar *ngIf="authUser"></app-menu-user-avatar>
      </div>
    </div>
  </div>
</nav>

<!-- Navbar Mobile (menu itens)-->
<div class="offcanvas offcanvas-start mobile-menu-us w-80" data-bs-scroll="true" tabindex="-1" id="mobileMenu" aria-labelledby="mobileMenuLabel">
  <div class="offcanvas-body">
    <ul class="navbar-nav nav-us">
      <li class="nav-item" *ngIf="!authUser">
        <a class="nav-link d-flex align-items-center" routerLink="/auth/login" data-bs-toggle="offcanvas">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 14H2L2 2L5 2V0L2 0C0.9 0 0 0.9 0 2L0 14C0 15.1 0.9 16 2 16H5V14ZM11 3L9.59 4.41L12.17 7L4 7L4 9L12.17 9L9.59 11.59L11 13L16 8L11 3Z" fill="black"/>
          </svg>
          <span class="ms-3">Entrar</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="authUser">
        <a class="nav-link d-flex align-items-center" (click)="authService.logout()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 2H14V14H11V16H14C15.1 16 16 15.1 16 14V2C16 0.900001 15.1 9.53674e-07 14 9.53674e-07H11V2ZM5 13L6.41 11.59L3.83 9H12V7H3.83L6.41 4.41L5 3L9.53674e-07 8L5 13Z" fill="black"/>
          </svg>
          <span class="ms-3">Sair</span>
        </a>
      </li>
      <hr class="m-0">
    </ul>
  </div>
</div>
